var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M315 125.903C315 128.976 312.671 130.903 310.485 130.903H39.5162C37.3286 130.903 35 128.976 35 125.903C35 122.83 37.3285 120.903 39.5162 120.903H310.485C312.671 120.903 315 122.83 315 125.903Z",
    stroke: "#232934",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315 224.808C315 227.88 312.671 229.808 310.485 229.808H39.5162C37.329 229.808 35 227.88 35 224.808C35 221.735 37.3284 219.808 39.5162 219.808H310.485C312.671 219.808 315 221.734 315 224.808Z",
    stroke: "#232934",
    strokeWidth: 20
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315 27.0001C315 30.0734 312.671 32 310.485 32H39.5162C37.3285 32 35 30.0729 35 27.0001C35 23.927 37.3286 22 39.5162 22H310.485C312.671 22 315 23.9265 315 27.0001Z",
    stroke: "#232934",
    strokeWidth: 20
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M315 323.71C315 326.783 312.671 328.71 310.485 328.71H39.5162C37.329 328.71 35 326.782 35 323.71C35 320.637 37.3284 318.71 39.5162 318.71H310.485C312.672 318.71 315 320.637 315 323.71Z",
    stroke: "#232934",
    strokeWidth: 20
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/Burger.8574b1971934f339bfa6def41d25b6ed.svg";
export { ForwardRef as ReactComponent };